/** @format */

import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

// import formDataReducer from "./reducers/formDataReducer";
import dataReducer from "./reducers/dataReducer";
import uiReducer from "./reducers/uiReducer";

const middleware = [thunk];

const reducers = combineReducers({
  data: dataReducer,
  /*   formData: formDataReducer, */
  UI: uiReducer,
});

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
        traceLimit: 25,
      })
    : compose;

const enhancer = composeEnhancers(applyMiddleware(...middleware));

const initialState = {};

const store = createStore(reducers, initialState, enhancer);

export default store;
